import BdcSettings from "../components/Bdc/Settings";

const BdcSettingsPage = () => <BdcSettings />;

export default BdcSettingsPage;
